// removed by extract-text-webpack-plugin
module.exports = {"Button":"QI7b2B9HFdWRqXJlhx5ZF","Success":"_2dHUtYmIiKVpRl3omZjpfb","Danger":"_2xnhNuUUklZ_76EhvNOs5Q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/Button.css
// module id = 180
// module chunks = 0